import { FC } from "react";
import { LoadingButton } from "@mui/lab";
import { Box, Stack, Typography } from "@mui/material";
import { ArrowForwardRounded } from "@mui/icons-material";

import { NotificationModal } from "@/shared/common/InfoPopup/NotificationModal";
import { ModalActionButton } from "@/shared/base/components/ModalActionButton/ModalActionButton";

import { createState } from "@/global/store/zustand_store";
import { useFilterApis } from "../../GameFilters/useFilterApis";
import { useTicketmaster } from "@/global/hooks/useTicketmaster";
import { useInternalAuth } from "@/global/hooks/useInternalAuth";
import { useTicketsdotcom } from "@/global/hooks/useTicketsdotcom";
import { useDynamicPricing } from "../DynamicPricing/useDynamicPricing";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { useFraudPrevention } from "@/global/context/FraudPreventionProvider";

export const useDynamicPricingModal = createState({
  isOpen: false,
  hasModalOpened: false,
});

export const DynamicPricingModal: FC = () => {
  const { sm } = useCssMediaQuery("down");
  const modalState = useDynamicPricingModal();
  const { oktaAuthLoading } = useTicketsdotcom();
  const { isLoading: isAuthLoading } = useTicketmaster();
  const { selectedPricing, isDynamicPricingEnabled } = useDynamicPricing();
  const { checkBrokerEmail } = useFraudPrevention();
  const { getInventoryFilters } = useFilterApis();
  const { redirectLoading } = useInternalAuth();

  function onClickYes() {
    if (!isDynamicPricingEnabled) return;
    modalState.set({ isOpen: false, hasModalOpened: true });
  }

  const handleConfirm = async () => {
    modalState.set({ isOpen: false });
    const cartConfirmBtn = document.getElementById(
      "confirm-game-selection-btn"
    );
    cartConfirmBtn?.click();
  };

  if (!isDynamicPricingEnabled || !selectedPricing) return null;

  return (
    <NotificationModal
      hideTitleIcon
      hidePrimaryButton
      hideSecondaryButton
      title="Choose Your Pricing Option"
      isOpen={modalState.isOpen}
      onClose={() => modalState.set({ isOpen: false, hasModalOpened: true })}
      paperProps={{ style: { marginLeft: 2, marginRight: 2 } }}
      renderBody={() => (
        <Box>
          <Box p={sm ? 2 : 3}>
            <Box>
              <Typography variant="body1">
                {selectedPricing.offerMoreMessage}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
      renderFooter={() => {
        return (
          <Stack
            py={2}
            px={2}
            gap={2}
            width={"100%"}
            justifyContent={"flex-end"}
            direction={"row"}
          >
            <LoadingButton
              loading={
                isAuthLoading ||
                getInventoryFilters.isLoading ||
                checkBrokerEmail.isLoading
              }
              size={"large"}
              disabled={
                isAuthLoading ||
                getInventoryFilters.isLoading ||
                checkBrokerEmail.isLoading ||
                oktaAuthLoading ||
                redirectLoading
              }
              variant={"outlined"}
              endIcon={<ArrowForwardRounded />}
              onClick={handleConfirm}
              sx={{
                width: sm ? "fit-content" : "180px",
                fontWeight: 600,
              }}
            >
              Continue
            </LoadingButton>

            <ModalActionButton
              size="small"
              variant="primary"
              onClick={onClickYes}
              style={{
                width: sm ? "fit-content" : "180px",
                fontWeight: 600,
                borderRadius: 99,
              }}
            >
              YES!
            </ModalActionButton>
          </Stack>
        );
      }}
    />
  );
};
